// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__3O5cA","icon":"search_icon__1_z9O","input":"search_input__1L84e","button":"search_button__2YcWQ"};